import { FC } from 'react'

import { ErrorMessage } from '../shared-form-styles'

export type ValidationMessageProps = {
  /** Nothing renders without a message, so callers can pass their error state straight through. */
  message: string | undefined
  id?: string
}

/**
 * The error under a control or a group of controls — "Enter your first line", "Add at least one
 * text option to save".
 */
export const ValidationMessage: FC<ValidationMessageProps> = ({ message, id }) =>
  message ? (
    <ErrorMessage id={id} role='alert'>
      {message}
    </ErrorMessage>
  ) : null
